<template>
  <div id="cardList">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="一级分类">
        <el-select
          style="width: 100px"
          size="mini"
          v-model="searchForm.firstClass"
          placeholder="请选择"
          :clearable="true"
          @change="onFirstClassChange"
          @clear="onFirstClassClear">
          <el-option
            v-for="item in firstClassList"
            :key="item.id"
            :label="item.className"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select :clearable="true" style="width: 100px" size="mini" v-model="searchForm.secondClass" placeholder="请选择">
          <el-option
            v-for="item in secondClassList"
            :key="item.id"
            :label="item.className"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否上线">
        <el-select :clearable="true" style="width: 100px" size="mini" v-model="searchForm.isWork" placeholder="请选择">
          <el-option
            v-for="item in isWorkList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="getData">查询</el-button>
        <el-button size="mini" @click="createCard">创建卡劵</el-button>
        <el-button size="mini" @click="exportToExcel">导出</el-button>
        <!--<el-button size="mini" @click="toRecommend">推荐</el-button>-->
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="cardName" label="卡券名称" width="180"></el-table-column>
      <el-table-column prop="firstClassName" label="一级分类"></el-table-column>
      <el-table-column prop="secondClassName" label="二级分类"></el-table-column>
      <el-table-column prop="buyPrice" label="回收价格"></el-table-column>
      <el-table-column prop="awardCredit" label="积分"></el-table-column>
      <el-table-column prop="operateName" label="操作用户"></el-table-column>
      <el-table-column prop="createTime" :formatter="dateFormatter" label="上传时间" width="180"></el-table-column>
      <el-table-column prop="recommend" label="是否推荐">
        <template slot-scope="scope">
          {{scope.row.recommend?"是":"否"}}
        </template>
      </el-table-column>
      <el-table-column prop="isWork" label="上线状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isWork"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-value="0"
            active-value="1"
            @change="isWorkChange(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="viewCard(scope.row)"
            type="text"
            size="small">
            查看
          </el-button>
          <el-button
            @click.native.prevent="editCard(scope.row)"
            type="text"
            size="small">
            编辑
          </el-button>
          <el-button
            @click.native.prevent="deleteCard(scope.row.id)"
            type="text"
            size="small">
            删除
          </el-button>
          <el-button
            @click.native.prevent="operateRecommend(scope.row)"
            type="text"
            size="small">
            {{scope.row.recommend?"取消推荐":"推荐"}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      @close="closeCardDialog"
      width="40%">
      <el-form :model="cardForm" :rules="rules" ref="cardForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="卡劵名称" prop="cardName">
          <el-col :span="22">
            <el-input v-model="cardForm.cardName" placeholder="请输入卡劵名称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品分类" required>
          <el-col :span="11">
            <el-form-item prop="firstClass">
              <el-select v-model="cardForm.firstClass" placeholder="请选一级分类" @change="fromFirstClassChange">
                <el-option v-for="item in firstClassList" :key="item.id" :label="item.className" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2"></el-col>
          <el-col :span="11">
            <el-form-item prop="secondClass">
              <el-select v-model="cardForm.secondClass" placeholder="请选二级分类">
                <el-option v-for="item in formSecondClassList" :key="item.id" :label="item.className" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="标签">
          <el-checkbox-group v-model="cardForm.labelId">
            <el-checkbox v-for="item in labelList" :key="item.id" :label="item.id" name="labelId">{{item.labelName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="来源" prop="sourceId">
          <el-col :span="22">
            <el-select v-model="cardForm.sourceId" placeholder="请选择卡券来源" multiple>
              <el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.id"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="11">
            <el-form-item label="回收价格" prop="buyPrice">
                <el-input v-model="cardForm.buyPrice" type="number" placeholder="回收价格，元"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="奖励积分" prop="awardCredit">
                <el-input v-model="cardForm.awardCredit" type="awardCredit" placeholder="奖励积分，分"></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="封面图片(建议尺寸160*110)" required>
          <el-upload
            ref="uploadCover"
            action=""
            class="icon-uploader"
            :on-change="handleCoverSuccess"
            :auto-upload="false"
            :show-file-list="false">
            <img v-if="cardForm.coverImage" :src="cardForm.coverImage" class="icon-img">
            <i v-else class="el-icon-plus icon-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品图片(建议尺寸375*258)" class="good-image" required>
          <el-upload
            ref="uploadGoodImg1"
            action=""
            class="icon-uploader"
            :on-change="handleGoodImage1Success"
            :auto-upload="false"
            :show-file-list="false">
            <img v-if="cardForm.goodImage1" :src="cardForm.goodImage1" class="icon-img">
            <i v-else class="el-icon-plus icon-uploader-icon"></i>
          </el-upload>
          <el-upload
            ref="uploadGoodImg2"
            action=""
            class="icon-uploader"
            :on-change="handleGoodImage2Success"
            :auto-upload="false"
            :show-file-list="false">
            <img v-if="cardForm.goodImage2" :src="cardForm.goodImage2" class="icon-img">
            <i v-else class="el-icon-plus icon-uploader-icon"></i>
          </el-upload>
          <el-upload
            ref="uploadGoodImg3"
            action=""
            class="icon-uploader"
            :on-change="handleGoodImage3Success"
            :auto-upload="false"
            :show-file-list="false">
            <img v-if="cardForm.goodImage3" :src="cardForm.goodImage3" class="icon-img">
            <i v-else class="el-icon-plus icon-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="产品介绍" prop="introduce">
          <el-col :span="22"><el-input type="textarea" v-model="cardForm.introduce"></el-input></el-col>
        </el-form-item>
        <el-form-item label="使用须知" prop="useExplain">
          <el-col :span="22"><el-input type="textarea" :rows="4" v-model="cardForm.useExplain"></el-input></el-col>
        </el-form-item>
        <el-form-item label="最低有效期">
          <el-col :span="22">
            <el-input v-model="cardForm.lastValidDays" type="number" placeholder="单位，天"></el-input>
            <p style="color: red">用户所传卡券剩余有效期低于此值的将无法回收</p>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="action != 'view'">
        <el-button @click="closeCardDialog">取 消</el-button>
        <el-button type="primary" @click="saveCardSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from "../utils/utils";
  import axios from "axios";
  export default {
    name: "card-list",
    data(){
      return{
        searchForm:{
          firstClass:null,
          secondClass:null,
          isWork:""
        },
        firstClassList:[],
        secondClassList:[],
        formSecondClassList:[],
        isWorkList:[{
          label:"是",
          value:"1"
        },{
          label:"否",
          value:"0"
        }],
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        },
        multipleSelection:[],
        selectIds:[],
        dialogTitle:"",
        dialogVisible:false,
        action:"",
        cardForm:{
          cardName:"",
          firstClass:null,
          secondClass:null,
          labelId:[],
          sourceId:[],
          buyPrice:null,
          awardCredit:null,
          coverImage:"",
          coverFile:null,
          goodImage1:"",
          goodImage1File:null,
          goodImage2:"",
          goodImage2File:null,
          goodImage3:"",
          goodImage3File:null,
          introduce:"",
          useExplain:"",
          lastValidDays:0,
        },
        id:null,
        rules:{
          cardName:[{ required: true, message: '卡劵名称不能为空', trigger: 'blur' }],
          firstClass:[{ required: true, message: '一级分类不能为空', trigger: 'change'  }],
          sourceId:[{ required: true, message: '来源不能为空', trigger: 'change'  }],
          secondClass:[{ required: true, message: '二级分类不能为空', trigger: 'change'  }],
          buyPrice:[{ required: true, message: '回收价格不能为空', trigger: 'blur' }],
          awardCredit:[{required: true, message: '奖励积分不能为空', trigger: 'blur' }],
          introduce:[{required: true, message: '产品介绍不能为空', trigger: 'blur' }],
          useExplain:[{required: true, message: '使用须知不能为空', trigger: 'blur' }],
        },
        labelList:[],
        sourceList:[]
      }
    },
    created(){
      this.getFirstClassList();
      this.getData();
      this.getLabel();
      this.getSource();
    },
    methods:{
      getSource(){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/queryCardSourceList",
          data:{},
          callback:(res => {
            this.sourceList = res.data.list;
          })
        })
      },
      getLabel(){
        utils.axiosMethods({
          method:"GET",
          url:"/api/cardManage/queryLabelAll",
          callback:(res => {
            this.labelList = res.data.list;
          })
        })
      },
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        let data = this.searchForm;
        data.condition = "create_time desc";
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/queryCard",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:data,
          callback:(res => {
            loading.close();
            this.tableData = res.data.list;
            this.pageInfo.total = res.data.total;
          }),
          catch:(err=>{
            loading.close();
          })
        })
      },
      getFirstClassList(){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/queryFirstClass",
          data:{},
          callback:(res => {
            this.firstClassList = res.data.list;
          })
        })
      },
      onFirstClassChange(val){
        if(val){
          this.getSecondClassList(val,(res => {
            this.secondClassList = res.data.list;
          }))
        }else{
          this.secondClassList = [];
        }
      },
      fromFirstClassChange(val){
        if(val){
          this.getSecondClassList(val,(res => {
            this.formSecondClassList = res.data.list;
          }))
        }else{
          this.formSecondClassList = [];
        }
      },
      getSecondClassList(supClassId,callback){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/querySecondClass",
          params:{
            supClassId:supClassId
          },
          callback:callback
        })
      },
      onFirstClassClear(){
        this.secondClassList = [];
        this.searchForm.secondClass = null;
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        let ids = [];
        val.map(item => {
          ids.push(item.id)
        });
        this.selectIds = ids;
      },
      isWorkChange(row){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/changeCardIsWord",
          params:{
            id:row.id,
            isWork:row.isWork == '1' ? '0' :'1'
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success(res.data.msg);
              this.getData();
            }else{
              this.$message.error(res.data.msg);
            }
          })
        })
      },
      viewCard(row){
        this.dialogTitle = "查看卡劵";
        this.action = "view";
        this.dialogVisible = true;
        this.id = row.id;
        this.cardForm = {
          cardName:row.cardName,
          firstClass:row.firstClass,
          secondClass:row.secondClass,
          labelId:row.labelId?row.labelId.split(',').map(id => id = parseInt(id)):[],
          buyPrice:row.buyPrice,
          sourceId:row.sourceId?row.sourceId.split(',').map(id => id = parseInt(id)):[],
          awardCredit:row.awardCredit,
          coverImage:"/api/"+row.coverImg,
          coverFile:null,
          goodImage1:row.goodImg1?"/api/"+row.goodImg1:"",
          goodImage1File:null,
          goodImage2:row.goodImg2?"/api/"+row.goodImg2:"",
          goodImage2File:null,
          goodImage3:row.goodImg3?"/api/"+row.goodImg3:"",
          goodImage3File:null,
          introduce:row.introduce,
          useExplain:row.useExplain,
          lastValidDays:row.lastValidDays,
        }
        this.getSecondClassList(row.firstClass,(res => {
          this.formSecondClassList = res.data.list;
        }))
      },
      editCard(row){
        this.dialogTitle = "编辑卡券";
        this.action = "update";
        this.dialogVisible = true;
        this.id = row.id;
        this.cardForm = {
          cardName:row.cardName,
          firstClass:row.firstClass,
          secondClass:row.secondClass,
          labelId:row.labelId?row.labelId.split(',').map(id => id = parseInt(id)):[],
          sourceId:row.sourceId?row.sourceId.split(',').map(id => id = parseInt(id)):[],
          buyPrice:row.buyPrice,
          awardCredit:row.awardCredit,
          coverImage:"/api/"+row.coverImg,
          coverFile:null,
          goodImage1:row.goodImg1?"/api/"+row.goodImg1:"",
          goodImage1File:null,
          goodImage2:row.goodImg2?"/api/"+row.goodImg2:"",
          goodImage2File:null,
          goodImage3:row.goodImg3?"/api/"+row.goodImg3:"",
          goodImage3File:null,
          introduce:row.introduce,
          useExplain:row.useExplain,
          lastValidDays:row.lastValidDays,
        }
        this.getSecondClassList(row.firstClass,(res => {
          this.formSecondClassList = res.data.list;
        }))
      },
      deleteCard(id){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/deleteCard",
          params:{
            id:id
          },
          callback:(res => {
            this.getData();
            if(res.data.code == 0){
              this.$message.success("恭喜你，删除成功！")
            }else{
              this.$message.error(res.data.msg);
            }
          })
        })
      },
      closeCardDialog(){
        this.dialogVisible = false;
        this.cardForm = {
          cardName:"",
          firstClass:null,
          secondClass:null,
          labelId:[],
          sourceId:[],
          buyPrice:null,
          awardCredit:null,
          coverImage:"",
          coverFile:null,
          goodImage1:"",
          goodImage1File:null,
          goodImage2:"",
          goodImage2File:null,
          goodImage3:"",
          goodImage3File:null,
          introduce:"",
          useExplain:"",
          lastValidDays:null,
        }
        this.$refs.uploadCover.clearFiles();
        this.$refs.uploadGoodImg1.clearFiles();
        this.$refs.uploadGoodImg2.clearFiles();
        this.$refs.uploadGoodImg3.clearFiles();
      },
      saveCardSure(){
        this.$refs.cardForm.validate((valid) => {
          if(valid){
            let url;
            let formData = new FormData();
            if(this.action == "add"){
              url = "/api/cardManage/insertCard"
              if(this.cardForm.coverFile){
                formData.append("files",this.cardForm.coverFile);
              }else{
                this.$message.error("请选择封面图片")
                return;
              }
              if(!this.cardForm.goodImage1File && !this.cardForm.goodImage2File && !this.cardForm.goodImage3File){
                this.$message.error("请选择至少一张商品图片")
                return;
              }
              if(this.cardForm.goodImage1File){
                formData.append("files",this.cardForm.goodImage1File);
              }
              if(this.cardForm.goodImage2File){
                formData.append("files",this.cardForm.goodImage2File);
              }
              if(this.cardForm.goodImage3File){
                formData.append("files",this.cardForm.goodImage3File);
              }

            }else{
              url = "/api/cardManage/updateCard"
              let changeList = []
              if(this.cardForm.coverFile){
                changeList.push("cover")
                formData.append("files",this.cardForm.coverFile);
              }
              if(this.cardForm.goodImage1File){
                changeList.push("goodImg1")
                formData.append("files",this.cardForm.goodImage1File);
              }
              if(this.cardForm.goodImage2File){
                changeList.push("goodImg2")
                formData.append("files",this.cardForm.goodImage2File);
              }
              if(this.cardForm.goodImage3File){
                changeList.push("goodImg3")
                formData.append("files",this.cardForm.goodImage3File);
              }
              formData.append("changeList",changeList.join(','))
              formData.append("id",this.id);
            }
            formData.append("cardName",this.cardForm.cardName);
            formData.append("firstClass",this.cardForm.firstClass);
            formData.append("secondClass",this.cardForm.secondClass);
            formData.append("labelId",this.cardForm.labelId.join(','));
            formData.append("buyPrice",this.cardForm.buyPrice);
            formData.append("sourceId",this.cardForm.sourceId.join(','));
            formData.append("awardCredit",this.cardForm.awardCredit);
            formData.append("introduce",this.cardForm.introduce);
            formData.append("useExplain",this.cardForm.useExplain);
            formData.append("lastValidDays",this.cardForm.lastValidDays?this.cardForm.lastValidDays:null);
            axios.post(url, formData)
              .then( response=> {
                if(response.data.code == 0){
                  this.$message({
                    message: '恭喜你，操作成功',
                    type: 'success'
                  });
                  this.getData();
                  this.closeCardDialog()
                }else{
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              })
          }
        })
      },
      createCard(){
        this.dialogTitle = "创建卡劵";
        this.action = "add";
        this.dialogVisible = true;
      },
      handleCoverSuccess(file, fileList){
        if(encodeURI(file.name).indexOf("%20") >= 0){
          this.$message.error("图片名称包含空格，请重命名后上传")
        }else{
          this.cardForm.coverImage = URL.createObjectURL(file.raw);
          this.cardForm.coverFile = file.raw;
        }
      },
      handleGoodImage1Success(file, fileList){
        if(encodeURI(file.name).indexOf("%20") >= 0){
          this.$message.error("图片名称包含空格，请重命名后上传")
        }else{
          this.cardForm.goodImage1 = URL.createObjectURL(file.raw);
          this.cardForm.goodImage1File = file.raw;
        }
      },
      handleGoodImage2Success(file, fileList){
        if(encodeURI(file.name).indexOf("%20") >= 0){
          this.$message.error("图片名称包含空格，请重命名后上传")
        }else{
          this.cardForm.goodImage2 = URL.createObjectURL(file.raw);
          this.cardForm.goodImage2File = file.raw;
        }
      },
      handleGoodImage3Success(file, fileList){
        if(encodeURI(file.name).indexOf("%20") >= 0){
          this.$message.error("图片名称包含空格，请重命名后上传")
        }else{
          this.cardForm.goodImage3 = URL.createObjectURL(file.raw);
          this.cardForm.goodImage3File = file.raw;
        }
      },
      // 日期格式化
      dateFormatter(row, column, cellValue, index){
        return utils.dateFormat(cellValue,"yyyy-MM-dd HH:mm:ss")
      },
      exportToExcel(){
        window.open("/api/cardManage/exportCardToExcel?firstClass="+(this.searchForm.firstClass ? this.searchForm.firstClass:"")+"&secondClass="
          +(this.searchForm.secondClass ? this.searchForm.secondClass:"")+"&isWork="+this.searchForm.isWork,"_parent");
      },
      toRecommend(){
        utils.axiosMethods({
          method:"GET",
          url:"/api/cardManage/toRecommend",
          params:{
            cardIds:this.selectIds.join(","),
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success("推荐成功")
              this.getData();
            }else{
              this.$message.error(res.data.msg);
            }
          })
        })
      },
      operateRecommend(row){
        let url,message;
        if(row.recommend){
          url = "/api/cardManage/deleteRecommend"
        }else{
          url = "/api/cardManage/addRecommend"
        }
        utils.axiosMethods({
          method:"GET",
          url:url,
          params:{
            cardId:row.id,
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success(res.data.msg)
              this.getData();
            }else{
              this.$message.error(res.data.msg);
            }
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #cardList{
    .block{
      float: right;
      margin-top: 20px;
    }
  }
</style>
<style lang="less">
  #cardList{
    .el-dialog__body{
      max-height: 400px;
      overflow: auto;
    }
    .icon-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .icon-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .icon-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .icon-img {
      width: 60px;
      height: 60px;
      display: block;
    }
    .good-image{
      .icon-uploader{
        display: inline-block;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/cardList.vue